export const feeder = {
  /**
   * Gets the programmatic name of the entire locale, with the language,
   *	country and variant separated by underbars. The Language is always lower case,
   *	and country is always upper case. If the language is missing,
   *	the string will begin with an underscore character.
   *	If both the language and country fields are missing,
   *	this function will return the empty string,
   *	even if the variant field is filled in (you cannot have a locale with just a variant--
   *	the variant must accompany a valid language or country code). Examples: "en"
   *
   */
  en: {
    feeder_management: "Feeder Management",
    feeder_information: "Feeder Information",
    customer_name: "Customer Name",
    pole_information: "Pole Information",
    add_pole: "Add Pole",
    add_hierarchy: "Add Hierarchy",
    switch_id: "Switch Id",
    feeder_name: "Feeder Name",
    feeder_type: "Feeder Type",
    lane: "Lane",
    ward: "Ward",
    model_number: "Model Number",
    serial_number: "Serial Number",
    locality: "Locality",
    city: "City",
    imei: "IMEI",
    controller_type: "Controller Type",
    meter_number: "Meter Number",
    oem_name: "OEM Name",
    longitude: "Longitude",
    latitude: "Latitude",
    longitude_direction: "Longitude Direction",
    latitude_direction: "Latitude Direction",
    total_load_capacity: "Total Load Capacity",
    warranty_details: "Warranty Details",
    installation_date: "Installation Date",
    warranty_expiry_date: "Warranty Expiry Date",
    sw_version: "SW Version",
    imsi: "IMSI",
    mobile_number: "Mobile Number",
    operator: "Operator",
    apn: "APN",
    user_name: "User Name",
    password: "Password",
    add_feeder: "Add Feeder",

    pole_number: "Pole Number",
    type_of_distribution: "Type Of Distribution",
    address_line1: "Address Line01",
    state: "State",
    postal_code: "Postal Code",
    country: "Country",
    p_n: "P-N",
    p_e: "P-E",
    e_n: "E-N",
    pole_height: "Pole Height",
    height_of_luminaries: "Height Of Luminaries",
    type_of_lamp: "Type Of Lamp",
    wattage: "Wattage",
    road_type: "Road Type",
    pole_arrangement: "Pole Arrangement",
    feeder_phase: "Feeder Phase",
    edit_feeder: "Edit Feeder",
    edit_pole: "Edit Pole",
    feeder_status: "Feeder Status",
    status: "Status",
    date: "Date",
    time: "Time",
    level: "Level",
    levelName: "Level Name",
    levelType: "Level Type",
    hierarchy: "Hierarchy"
  },

  ar: {
    feeder_management: "إدارة الطاعم",
    feeder_information: "معلومات الطاعم",
    customer_name: "اسم الزبون",
    pole_information: "معلومات العمود",
    add_pole: "أضف العمود",
    add_hierarchy: "أضف التسلسل الهرمي",
    switch_id: "تغيير الهوية",
    feeder_name: "اسم الطاعم",
    feeder_type: "نوع المغذي",
    lane: "الخط",
    ward: "الوارد",
    model_number: "رقم الموديل",
    serial_number: "الرقم التسلسلي ",
    locality: "المنطقة",
    city: "المدينة",
    imei: "IMEI",
    controller_type: "نوع وحدة التحكم",
    meter_number: "متر",
    oem_name: "اسم OEM",
    longitude: "خط الطول",
    latitude: "خط العرض",
    longitude_direction: "اتجاه خط الطول",
    latitude_direction: "اتجاه خط العرض",
    total_load_capacity: "سعة التحميل الإجمالية",
    warranty_details: "تفاصيل الضمان",
    installation_date: "تاريخ التثبيت",
    warranty_expiry_date: "تاريخ انتهاء الضمان",
    sw_version: "إصدار SW",
    imsi: "IMSI",
    mobile_number: "رقم الهاتف المحمول",
    operator: "المشغل أو العامل",
    apn: "خاصة بك",
    user_name: "اسم االمستخدم",
    password: "كلمة المرور",
    add_feeder: "إضافة المغذي",

    pole_number: "رقم العمود",
    type_of_distribution: "نوع التوزيع",
    address_line1: "سطر العنوان 01",
    state: "حالة",
    postal_code: "الرمز البريدي",
    country: "الدولة",
    p_n: "ف ن",
    p_e: "بي إي",
    e_n: "E-N",
    pole_height: "ارتفاع العمود",
    height_of_luminaries: "ارتفاع النجوم",
    type_of_lamp: "نوع المصباح",
    wattage: "القوة الكهربائية",
    road_type: "نوع الطريق",
    pole_arrangement: "ترتيب العمود",
    feeder_phase: "مرحلة التغذية",
    edit_feeder: "تحرير الطاعم",
    edit_pole: "تحرير العمود",
    feeder_status: "حالة التغذية",
    status: "الحالة",
    date: "التاريخ",
    time: "الوقت",
    level: "المستوى",
    levelName: "اسم المستوى",
    levelType: "نوع المستوى",
    hierarchy: "التسلسل الهرمي"
  }
};
